<template>
    <div class="espa-mobile"><a href="https://www.propnroll.com/espa.pdf" target="_blank"><img alt="espa" src="../assets/espa.jpg" /></a></div>
    <header class="main-header">
        <div class="logo"><router-link :to="{ name: 'Home' }"><img alt="propnroll" :src='setLogo()' /></router-link></div>
        <div class="left-menu">
            <ul>
                <li><a href="https://www.propnroll.com/espa.pdf" target="_blank"><img alt="espa" class="espa" src="../assets/espa.jpg" /></a></li>
                <!--<li><span v-if="isLoggedIn"><a @click="logout">Logout</a></span></li>-->
                <li class="cart-top">
                    <router-link :to="{ name: 'Contact' }">
                        <img alt="user" src="../assets/email.svg" class="menu-user white-img" />
                        <img alt="user" src="../assets/email-black.svg" class="menu-user black-img" />
                    </router-link>
                </li>
                <li v-if="isLoggedIn" v-show="$route.params.id != '0'">
                    <a @click="userMenu()">
                        {{user.firstname}} &nbsp;
                        <!--<i class="fa fa-user" aria-hidden="true"></i>-->
                        <img alt="user" src="../assets/user.svg" class="menu-user white-img" />
                        <img alt="user" src="../assets/user-black.svg" class="menu-user black-img" />
                    </a>
                </li>
                <li v-if="!isLoggedIn" v-show="$route.params.id != '0'">
                    <a @click="openLogin()">
                        <!--<i class="fa fa-user" aria-hidden="true"></i>-->
                        <img alt="user" src="../assets/user.svg" class="menu-user white-img" />
                        <img alt="user" src="../assets/user-black.svg" class="menu-user black-img" />
                    </a>
                </li>
                <li v-show="$route.params.id != '0'">
                    <a @click="focusInputSearch()">
                        <img alt="search" src="../assets/search.svg" class="menu-search white-img" />
                        <img alt="search" src="../assets/search-black.svg" class="menu-search black-img" />
                        <!--<i class="fa fa-search" aria-hidden="true"></i>-->
                    </a>
                </li>
                <li class="cart-top" v-show="$route.params.id != '0'">
                    <a class="shopping-cart" @click="openListItems()">
                        <!--<i class="fa fa-shopping-basket" aria-hidden="true"></i>-->
                        <img alt="basket" src="../assets/basket.svg" class="menu-basket white-img" />
                        <img alt="basket" src="../assets/basket-black.svg" class="menu-basket black-img" />
                    </a>
                    <span class="cart-qty-top">{{cartQuantity}}</span>
                </li>
            </ul>
        </div>
    </header>
    <transition name="fade-modal">
        <login v-if="showModal" @register-clicked="openLoginRegister()" @close-clicked="openLogin()" />
    </transition>
    <transition name="fade-modal">
        <register v-if="showModalRegister" @close-clicked="openLoginRegister()" />
    </transition>
    <transition name="fade-modal">
        <items v-if="showListItems" @close-clicked="openListItems()" />
    </transition>
    <transition name="fade-modal">
        <user-menu v-if="showUserMenu" @close-clicked="userMenu()" />
    </transition>
    <transition name="fade-modal">
        <search v-if="showSearch" @close-clicked="focusInputSearch()" />
    </transition>
</template>


<script>

    //https://www.npmjs.com/package/@trevoreyre/autocomplete-vue#search

    import login from './Login.vue';
    import userMenu from './UserMenu.vue';
    import register from './Register.vue';
    import items from './ListItems.vue';
    import { mapGetters } from "vuex";
    import search from './Search.vue'

    export default {
        name: "NavMenu",
        data() {
            return {
                showModal: false,
                showModalRegister: false,
                showListItems: false,
                showSearch: false,
                showUserMenu: false
            }
        },
        components: {
            login,
            register,
            items,
            userMenu,
            search
        },
        methods: {
            focusInputSearch() {
                this.showSearch = !this.showSearch;
                //this.showSearch = true;
                //this.timer = setTimeout(() => {
                //    this.$refs.searchInput.focus();
                //}, 200);
            },
            openLogin() {
                //this.showModal = true;
                this.showModal = !this.showModal;
            },
            userMenu() {
                //alert('menu');
                //this.showModal = true;
                this.showUserMenu = !this.showUserMenu;
            },
            openListItems() {

                this.$router.push('/cart');
                ////this.showModal = true;
                //this.showListItems = !this.showListItems;
            },
            openLoginRegister() {
                this.showModal = false;
                this.showModalRegister = !this.showModalRegister;
            },
            setLogo() {
                //this.whiteLogo = false;
                //console.log(this.$route.name);
                if (this.$route.name === 'Contact' || this.$route.name === 'Wrap' || this.$route.name === 'ElementItem'
                    || this.$route.name === 'Decor' || this.$route.name === 'DecorItem' || this.$route.name === 'Product'
                    || this.$route.name === 'CategoryListing'
                    || this.$route.name === 'Cart' || this.$route.name === 'Partner' || this.$route.name === 'PartnerRent') {
                    return require('../assets/' + 'logo-black.svg')
                }
                else {
                    return require('../assets/' + 'logo-white.svg')
                }

            },
            logout: function () {
                this.$store.dispatch('logout')
                    .then(() => {
                        //this.$router.push('/login')
                        this.$router.push('/')
                    })
            }
        },
        computed: {
            currentRouteName() {
                return this.$route.name;
            },
            ...mapGetters([
                "cartQuantity"
            ]),
            isLoggedIn: function () { return this.$store.getters.isLoggedIn },
            user: function () { return this.$store.getters.user }
        },
        created() {
            this.$store.dispatch('getCartItems', this.getUID());
        }
    }
</script>

<style>
    .white-img, .black-img {
        display: none;
    }

    .white-style .social i, .white-style .left-menu i {
        color: #fff;
    }

    .black-style .social i, .black-style .left-menu i {
        color: #000;
    }

    .white-style .social i, .white-style .left-menu .white-img {
        display: inline-block;
    }

    .black-style .social i, .black-style .left-menu .black-img {
        display: inline-block;
    }

    .menu-user {
        width: 20px;
        height: 20px;
    }

    .menu-search {
        width: 20px;
        height: 20px;
    }

    .menu-basket {
        width: 20px;
        height: 20px;
    }
    .espa {
        height:30px;
        vertical-align:middle;
    }
    .espa-mobile {
        display:none;
    }
    .cart-top {
        position: relative;
    }

    .cart-qty-top {
        display: inline-block;
        color: white;
        background-color: black;
        border-radius: 48%;
        padding: 3px 6px;
        font-size: 9px;
        top: -11px;
        position: absolute;
        right: -8px;
    }
    
    .fade-modal-enter-active, .fade-modal-leave-active {
        transition: opacity .3s;
    }

    .fade-modal-enter-from, .fade-modal-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }

    .left-menu a {
        cursor: pointer;
    }

        .left-menu a:not([href]):not([class]) {
            color: black;
        }

    .white-style .left-menu a:not([href]):not([class]) {
        color: white;
    }

    @media screen and (max-width: 580px) {
        .espa {
            display:none;   
        }
        .espa-mobile {
            display: block;
            text-align:right;
            width:100%;
        }
        .espa-mobile img{
            width:140px;
        }
    }

</style>
